export enum CommandStepState {
  New,
  Processing,
  Complete,
  Failed,
}
